var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3185 6.20168C4.51095 6.39971 4.50642 6.71626 4.30838 6.90871C4.11034 7.10116 3.79379 7.09663 3.60135 6.89859L0.644582 3.85597C0.45802 3.66399 0.455759 3.35914 0.639453 3.16441L3.4321 0.204073C3.62159 0.00320408 3.93804 -0.00601965 4.13891 0.18347C4.33977 0.37296 4.349 0.689408 4.15951 0.890276L1.69537 3.50238L4.3185 6.20168Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.8d4d6b425f98d4ed10bd9131832325ec.svg";
export { ForwardRef as ReactComponent };